<template>
  <ElDialog
    v-bind="$attrs"
    :model-value="modelValue"
    class="app-modal"
    :show-close="false"
    :close-on-click-modal="closeable"
    :close-on-press-escape="closeable"
    @update:model-value="emit('update:modelValue', $event)"
  >
    <AppButton v-if="closeable" variant="plain" size="small" class="app-modal__close" aria-label="Close" @click="emit('update:modelValue', false)">
      <AppIcon type="x" :size="22" />
    </AppButton>

    <slot />
  </ElDialog>
</template>

<script setup>
import { ElDialog } from "element-plus";
import AppButton from "@/components/ui/AppButton.vue";
import AppIcon from "@/components/ui/AppIcon.vue";

defineOptions({ inheritAttrs: false });

defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
  closeable: {
    type: Boolean,
    default: true,
  },
});

const emit = defineEmits(["update:modelValue"]);
</script>

<style lang="scss">
.el-dialog.app-modal {
  border-radius: 14px;
  box-shadow: 0 24px 64px -16px rgba($color-ink, 0.35);
  max-width: 640px;
  padding: 28px 32px;
  width: 90%;

  .el-dialog__header {
    display: none;
  }

  .el-dialog__body {
    color: $color-ink;
  }

  .app-modal__close {
    color: $color-text-muted;
    padding: 0 4px;
    position: absolute;
    right: 20px;
    top: 20px;
  }

  .app-modal__close + :is(h1, h2, h3, h4) {
    margin-top: 0;
    padding-right: 40px;
  }
}
</style>
